import { useIntl } from 'react-intl-next';

import { type UserConvoAIStreamingConfig } from '@atlassian/ai-agent-streaming';
import type { AiFeatureRequestEnvelopeSuggestIssuesDocumentationRequest } from '@atlassian/convo-ai-api';

export const useBuildIssueSuggestionsRequest = (
	markdownPlusContent: string,
	pageAri: string,
	isConvoAIMigrationEnabled: boolean,
): [AiFeatureRequestEnvelopeSuggestIssuesDocumentationRequest, UserConvoAIStreamingConfig] => {
	const { locale } = useIntl();

	return [
		{
			ai_feature_input: {
				context: {
					primary_text: markdownPlusContent,
					input_mime_type: 'text/markdown',
					source_ari: pageAri,
				},
				source: 'CONFLUENCE',
				locale,
				suggested_issues_config: {
					max_issues: 10,
					suggested_issue_field_types: [
						{
							issue_type: 'Task',
							fields: [
								{
									field_name: 'Summary',
									field_type: 'Short-Text',
								},
								{
									field_name: 'Description',
									field_type: 'Paragraph',
								},
							],
						},
					],
				},
				sourceType: 'string',
			},
		},
		{
			apiPath: 'v2/ai-feature/jira/issue/source-type/documentation/suggestions/stream',
			enablePartialJson: false,
			skip: !markdownPlusContent || !isConvoAIMigrationEnabled,
			headers: {
				'x-experience-id': 'ai-issue-create-confluence-bulk',
				'x-product': 'confluence',
			},
		},
	];
};
